// removed by extract-text-webpack-plugin
module.exports = {"textAppContainer":"textAppContainer--uHdI6","phoneNumberInitial":"phoneNumberInitial--2UKp-","phoneNumberError":"phoneNumberError--i7bie","phoneNumberSuccess":"phoneNumberSuccess--tmp-1","getLinkButton":"getLinkButton--2lsgU","buttonContainer":"buttonContainer--1G42-","inputContainer":"inputContainer--3_oUw","phoneIcon":"phoneIcon--2Bc8R","clientNotReady":"clientNotReady--7GeHX"};


/*****************
 ** WEBPACK FOOTER
 ** ./shared-components/TextAppForm/styles.scss
 ** module id = 1491
 ** module chunks = 17
 **/